import React from 'react';
import { StyledFooter, FooterAlignment, FooterCopyRight } from './styles';

const FooterLayout = () => {
  return (
    <div>
      <StyledFooter style={{ padding: '0px' }}>
        <FooterAlignment>
          <FooterCopyRight>
            <span>© 2025 Rubus Digital Inc.</span>
          </FooterCopyRight>
        </FooterAlignment>
      </StyledFooter>
    </div>
  );
};

export default FooterLayout;
